
import { useState, useEffect } from 'react';

interface ScrollDetectionOptions {
  threshold?: number; // percentage (0-100)
  delay?: number; // milliseconds
}

export const useScrollDetection = ({ threshold = 30, delay = 0 }: ScrollDetectionOptions = {}) => {
  const [isTriggered, setIsTriggered] = useState(false);
  const [scrollPercentage, setScrollPercentage] = useState(0);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;
      const percentage = (scrolled / scrollHeight) * 100;
      
      setScrollPercentage(percentage);
      
      if (percentage >= threshold && !isTriggered) {
        if (delay > 0) {
          timeoutId = setTimeout(() => setIsTriggered(true), delay);
        } else {
          setIsTriggered(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [threshold, delay, isTriggered]);

  const reset = () => setIsTriggered(false);

  return { isTriggered, scrollPercentage, reset };
};
